// @ts-ignore no types
import type {
  AuctionBlueprintLiveReactiveArgs,
  AuctionBlueprintScheduledOnlineReactiveArgs,
} from '@adc/blueprint'
import { type Maybe, type AuctionSegment } from '@adc/sdk/types'
import * as graph from '@adc/sdk'
import { FeatureFlags } from 'common/context/listing'

interface ShouldShowSealedBidTreatmentProps {
  segment:
    | Maybe<
        AuctionSegment | AuctionBlueprintScheduledOnlineReactiveArgs['segment']
      >
    | AuctionBlueprintLiveReactiveArgs['segment']
  featureFlags: FeatureFlags
}

export const shouldShowSealedBidTreatment = ({
  segment,
  featureFlags,
}: ShouldShowSealedBidTreatmentProps): boolean => {
  return Boolean(
    featureFlags &&
      featureFlags['fe.resi.enable-private-seller'] &&
      segment &&
      segment.__typename === 'OnlineAuctionSegment' &&
      segment.segment_type === graph.enums.OnlineAuctionSegmentType.SealedBid
  )
}
